import React from 'react';

const Delete = ({ onClick }) => {
  return (
    <button onClick={onClick} className='delete-button'>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='14'
        height='18'
        viewBox='0 0 14 18'
        fill='none'
      >
        <path
          d='M10.3542 15.7153C10.3472 15.8056 10.2708 15.875 10.1806 15.875H3.8125C3.72222 15.875 3.64583 15.8056 3.63889 15.7153L2.625 5.25H0.75L1.77778 15.8958C1.88194 16.9514 2.75694 17.75 3.81944 17.75H10.1875C11.2431 17.75 12.1181 16.9514 12.2153 15.8958L13.2431 5.25H11.3681L10.3542 15.7153Z'
          fill='#FF0037'
        />
        <path
          d='M7.9375 2.125V0.25L6.0625 0.875V2.125H0.75V4H13.25V2.125H7.9375Z'
          fill='#FF0037'
        />
        <path d='M6.375 5.25H4.5V14.625H6.375V5.25Z' fill='#FF0037' />
        <path d='M9.5 5.25H7.625V14.625H9.5V5.25Z' fill='#FF0037' />
      </svg>
    </button>
  );
};

export default Delete;
